import React from 'react';

export default class Header extends React.Component {
  render() {
    return (
      <div className='header-container'>
        <div className='banner-text-container'>
          <a href='https://www.groundcontrolsystems.com/' target='_blank'>
            <img id='logo' src='assets/img/logo-edited.png' />
          </a>
          <div className='banner-text'>
            Go{' '}
            <span>
              Configure<span className='trademark'>™</span>
            </span>
          </div>
        </div>
        <img src='assets/img/banner-image-bw.jpg' />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/index.js